import { atom } from "recoil";
import AddTicketModel from "../Models/AddTikcketModel";
export const ticketSate = atom({
  key: "ticketSate", // unique ID (with respect to other atoms/selectors)
  default: new AddTicketModel(), // default value (aka initial value)
});
